module.exports = __webpack_public_path__ + "static/media/undraw_server_status_5pbv_yellow.1d0c1d46.svg";